import { render } from "./Spinner.vue?vue&type=template&id=7b6c61d0&scoped=true&ts=true"
import script from "./Spinner.vue?vue&type=script&lang=ts"
export * from "./Spinner.vue?vue&type=script&lang=ts"

import "./Spinner.vue?vue&type=style&index=0&id=7b6c61d0&lang=scss&scoped=true"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6c61d0"]])

export default __exports__